"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.YYYY_MM_DD = exports.TESTS = exports.M_D_YYYY = exports.MM_DD_YYYY = exports.MMM_YYYY = exports.MMM_DD_YYYY = void 0;
var _luxon = require("luxon");
var _DateTimeless = require("../DateTimeless");
/** ****************************
 * HELPERS
 */

const isDefined = v => v !== undefined && v !== null;
const isEmptyString = v => typeof v === 'string' && v.trim() === '';
const isValidInput = v => isDefined(v) && !isEmptyString(v);
const protect = fn => date => {
  if (!isValidInput(date)) {
    return date;
  }
  return fn(date);
};
const toISO = date => new _DateTimeless.DateTimeless(date).toISOString();
const createDT = date => {
  const dt = _luxon.DateTime.fromISO(toISO(date));
  dt.setLocale('en-US');
  return dt;
};

/** ****************************
 * EXPORTABLE FUNCTIONS
 */

// @example 1/1/1970
const M_D_YYYY = protect(date => {
  const dt = createDT(date);
  return dt.toFormat('L/d/yyyy');
});

// @example 01/01/1970
exports.M_D_YYYY = M_D_YYYY;
const MM_DD_YYYY = protect(date => {
  const dt = createDT(date);
  return dt.toFormat('LL/dd/yyyy');
});

// @example Jan 1970
exports.MM_DD_YYYY = MM_DD_YYYY;
const MMM_YYYY = protect(date => {
  const dt = createDT(date);
  return dt.toFormat('LLL yyyy');
});

// @example Jan 1, 1970
exports.MMM_YYYY = MMM_YYYY;
const MMM_DD_YYYY = protect(date => {
  const dt = createDT(date);
  return dt.toFormat('LLL d, yyyy');
});

// @example Jan 1, 1970
exports.MMM_DD_YYYY = MMM_DD_YYYY;
const YYYY_MM_DD = protect(date => {
  const dt = createDT(date);
  return dt.toFormat('yyyy-LL-dd');
});
exports.YYYY_MM_DD = YYYY_MM_DD;
const TESTS = {
  toISO,
  createDT,
  M_D_YYYY,
  MM_DD_YYYY,
  MMM_YYYY,
  MMM_DD_YYYY,
  YYYY_MM_DD
};
exports.TESTS = TESTS;
var _default = {
  M_D_YYYY,
  MM_DD_YYYY,
  MMM_YYYY,
  MMM_DD_YYYY,
  YYYY_MM_DD,
  TESTS
};
exports.default = _default;